import jsPDF from "jspdf";
import { Button, Popup } from "semantic-ui-react";

/*
  When this button is clicked, we will open the cover letter in a new tab.
*/
export default function CoverLetterButton({
  dashboardCard,
  post,
  mini,
  text,
  icon,
}) {
  if (!dashboardCard) return null;
  const scrapedUrl = post?.scrapedUrl;
  const coverLetter = post?.coverLetter;

  const openPdfInNewTab = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const fontSize = 14;
    doc.setFontSize(fontSize);
    const margin = 40;
    const pageWidth = doc.internal.pageSize.getWidth();
    const contentWidth = pageWidth - 2 * margin;
    const lines = doc.splitTextToSize(coverLetter, contentWidth);
    doc.text(lines, margin, margin);
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  if (text) {
    return (
      <Popup
        content="View Cover Letter"
        trigger={
          <a
            href={scrapedUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={openPdfInNewTab}
          >
            {!icon ? (
              <Button
                circular
                icon="envelope outline"
                color="blue"
                size="small"
              >
                {text}
              </Button>
            ) : (
              icon
            )}
          </a>
        }
      />
    );
  }

  if (mini) {
    return (
      <Popup
        content="View Cover Letter"
        trigger={
          <a
            href={scrapedUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={openPdfInNewTab}
          >
            {!icon ? (
              <Button
                circular
                icon="envelope outline"
                color="blue"
                size="mini"
              />
            ) : (
              icon
            )}
          </a>
        }
      />
    );
  }

  return (
    <Popup
      content="View Cover Letter"
      trigger={
        <a
          href={scrapedUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={openPdfInNewTab}
        >
          {!icon ? (
            <Button
              circular
              icon="envelope outline"
              color="blue"
              size="small"
            />
          ) : (
            icon
          )}
        </a>
      }
    />
  );
}
